function Select({
  id,
  label,
  disabled,
  required,
  name,
  onChange,
  value,
  placeholder,
  // Bug real (auditoría 2026-08-14): options.map sin guarda — un caller que
  // no pasara options (undefined) crasheaba con
  // "Cannot read properties of undefined (reading 'map')".
  options = [],
  hint,
  className = "mb-3",
  floating = true,
  border = true,
  warning,
}) {
  return (
    <div
      className={`${floating ? "form-floating" : ""} ${className ?? "mb-3"}`}
    >
      {label && !floating && (
        <label
          className={`form-label ${warning ? 'text-danger fw-bold' : ''}`}
          htmlFor={id}
          dangerouslySetInnerHTML={{ __html: label }}
        />
      )}
      <select
        disabled={disabled}
        required={required}
        id={id}
        name={name}
        onChange={onChange}
        value={value}
        className={`form-select ${!border ? "border-0" : ""} ${warning ? 'is-invalid' : ''}`}
      >
        {!value && placeholder && <option value="">{placeholder}</option>}
        {options.map((option) => (
          <option value={option.value} key={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {label && floating && (
        <label
          className={`form-label ${warning ? 'text-danger fw-bold' : ''}`}
          htmlFor={id}
          dangerouslySetInnerHTML={{ __html: label }}
        />
      )}
      {hint && (
        <div className="form-text" dangerouslySetInnerHTML={{ __html: hint }} />
      )}
    </div>
  );
}

export default Select;
